import moment from 'moment'

export const getShortDate = date => {

  const SEC_IN_MINUTE = 60,
        SEC_IN_HOUR = 3600,
        SEC_IN_DAY = 86400,
        dateInSeconds = new Date(date).getTime() / 1000,
        nowInSeconds = new Date().getTime() / 1000,
        diffInSec = nowInSeconds - dateInSeconds

  if(diffInSec < 0){
    return '0 seconds ago'
  }

  if (diffInSec < SEC_IN_MINUTE){
    const seconds = Math.floor(diffInSec)
    if(seconds == 1) return(`${seconds} second ago`)
    else return(`${seconds} seconds ago`)
  }

  if (diffInSec >= SEC_IN_MINUTE && diffInSec < SEC_IN_HOUR){
    const minutes = Math.floor(diffInSec/SEC_IN_MINUTE)
    if(minutes == 1) return(`${minutes} minute ago`)
    else return(`${minutes} minutes ago`)
  }

  if (diffInSec >= SEC_IN_HOUR && diffInSec < SEC_IN_DAY) {
    const hours = Math.floor(diffInSec/SEC_IN_HOUR)
    if(hours == 1) return(`${hours} hour ago`)
    else return(`${hours} hours ago`)
  }

  if(diffInSec >= SEC_IN_DAY){
    return(moment(date).format('D MMM'))
  }

}

export const getActivityTimestamp = date => {
  return (moment(date).format('LT'))
}

export const getTooltipTimestamp = date => {
  return moment(date).calendar()
}

export const isExpiredInteraction = created => {
  const  SEC_IN_DAY = 86400
  const now = new Date().getTime() / 1000
  const timeInSec = Date.parse(created) / 1000
  return now - timeInSec > SEC_IN_DAY
}